import React from 'react';
import { Helmet } from 'react-helmet-async';
import { GalleryGrid } from '../components/GalleryGrid';
import { imageUrl } from '../lib/images';

export default function Gallery() {
  return (
    <div className="pt-20">
      <Helmet>
        <title>Galleri & Billeder af Udført Arbejde | DK Grøn Service</title>
        <meta name="description" content="Se billeder og resultater af vores arbejde med ejendomsservice, græsslåning, hækklipning og havearbejde. Få inspiration og se vores høje kvalitetsniveau." />
        <meta property="og:title" content="Galleri & Billeder af Udført Arbejde | DK Grøn Service" />
        <meta property="og:description" content="Se billeder og resultater af vores arbejde med ejendomsservice, græsslåning, hækklipning og havearbejde. Få inspiration til dit projekt." />
        <meta property="og:type" content="website" />
      </Helmet>

      <section className="py-24 bg-emerald-50">
        <div className="container mx-auto px-4 text-center max-w-3xl">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-emerald-950 mb-6">Galleri</h1>
          <p className="text-xl text-emerald-800/70">
            Et billede siger mere end tusind ord. Her kan du se et udpluk af de opgaver, vi har løst for vores kunder.
          </p>
        </div>
      </section>

      <section className="py-24 bg-white">
        <div className="container mx-auto px-4">
          <GalleryGrid />
        </div>
      </section>

      {/* CTA */}
      <section className="relative py-24 overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img 
            src={imageUrl("image00016.jpeg", "width=1400,quality=75,format=auto")} 
            alt="Baggrund" 
            className="w-full h-full object-cover"
            loading="lazy"
            decoding="async"
          />
          <div className="absolute inset-0 bg-emerald-950/85 backdrop-blur-[2px]"></div>
        </div>

        <div className="container relative z-10 mx-auto px-4 text-center max-w-3xl text-white">
          <h2 className="text-3xl md:text-4xl font-bold mb-8">Skal vi også hjælpe dig?</h2>
          <p className="text-xl text-emerald-50/80 mb-12">
            Vi tager gerne en snak om dine behov og giver et uforpligtende tilbud på din opgave.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a
              href="tel:+4542442359"
              className="bg-red-600 text-white px-10 py-5 rounded-2xl font-bold text-lg hover:bg-red-500 transition-all shadow-xl hover:scale-105 active:scale-95"
            >
              Ring: 42 44 23 59
            </a>
            <a
              href="mailto:Djensen2@me.com"
              className="bg-white text-emerald-900 px-10 py-5 rounded-2xl font-bold text-lg hover:bg-emerald-50 transition-all shadow-sm hover:scale-105 active:scale-95"
            >
              Skriv en mail
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
